import { FC, SVGAttributes } from "react";

const PlusSmall: FC<SVGAttributes<SVGSVGElement>> = ({
  width = "11px",
  height = "11px",
  ...rest
}) => (
  <svg
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    {...rest}
  >
    <path
      d="M5.41667 0.75V10.0833M0.75 5.41667H10.0833"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export { PlusSmall };
